var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"archive-dist",attrs:{"aria-hidden":"true"}},_vm._l((_vm.bars),function(bar){return _c('span',{key:bar.key,staticClass:"archive-dist-col",class:{ 'is-self': bar.self, 'is-loss': bar.loss }},[_c('span',{staticClass:"archive-dist-bar",style:({ height: _vm.barHeight(bar.count) })})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }